export default __webpack_public_path__ + "static/media/bo-shoppers-desktop.2a145d72.png";